import { mapActions, mapMutations, mapGetters } from "vuex";
import {
  resetUserPassword,
  RegisterCustomer,
  CreateSoUser,
  updateUser,
  signInWithPassword,
} from "./../../../src/api/services/userService";
export default {
  async mounted(isDesktop, registerObj) {
    registerObj.checkGoogleLoaded();
  },
  methods: {
    ...mapActions([
      "signUserIn",
      "signUserUp",
      "signUserInFacebook",
      "signUserInGoogle",
      "logout",
    ]),
    ...mapMutations(["setStoreLoaded", "setUser", "setStore"]),
    ...mapGetters(["user"]),
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.storeid },
      });
    },
    getMax() {
      let country = "AU";
      if (this.currentStoreDoc && this.currentStoreDoc.Location)
      {
         country = this.currentStoreDoc.Location.Country;
      }
      return country == "AU" ? 10 : 15;
    },
    getRegex() {
      let country = "AU";
      if (this.currentStoreDoc && this.currentStoreDoc.Location)
      {
         country = this.currentStoreDoc.Location.Country;
      }
      return country == "AU" ? /04\d{8}/ : /\d/;
    },
    signOut() {
      this.logout();
      this.goBack();
    },
    loadRecoveryPasswordForm(base64User) {
      let that = this;
      const decodedUserDocFromUrl = JSON.parse(
        new Buffer(base64User, "base64").toString("ascii")
      );

      signInWithPassword(
        decodedUserDocFromUrl.Email,
        decodedUserDocFromUrl.ResetPasswordToken
      )
        .then(() => {
          that.UserDoc = decodedUserDocFromUrl;
          that.IsNewUser = that.UserDoc.IsNewUser;
          that.setStoreLoaded();
          that.setStore(that.storeid);
        })
        .catch(() => {
          that.recoveryLinkExpired = true;
          window.setTimeout(function() {
            that.signOut();
          }, 4000);
        });
    },
    async resetUserPassword() {
      let that = this;
      if (that.loading) return;
      this.$validator.validateAll().then(async (valid) => {
        if (!valid) return;
        that.loading = true;
        that.UserDoc.Company_ID = this.storeid;
        resetUserPassword(that.UserDoc).then(() => {
          that.registrationResponse = {
            status: 200,
            msg: "Registration completed successfully.",
          };
          that.loading = false;
          window.setTimeout(function() {
            that
              .signUserIn({
                email: that.UserDoc.Email,
                password: that.UserDoc.Password,
              })
              .then(() => {
                if (!that.storeid) that.$router.push("/");
                else {
                  that.$router.push(`../../../../store/${that.storeid}`);
                }
              });
          }, 2000);
        });
      });
    },

    checkGoogleLoaded() {
      var that = this;
      var interval = setInterval(() => {
        try {
          if (google && google.maps) {
            that.googleLoaded = true;
            clearInterval(interval);
          }
        } catch {
          that.googleLoaded = false;
        }
      }, 500);
    },
    isValidDate(s) {
      if (s && s != "") {
        var bits = s.split("/");
        var d = new Date(bits[2], bits[1] - 1, bits[0]);
        var valid =
          d.getFullYear() == bits[2] &&
          d.getMonth() + 1 == bits[1] &&
          bits[2].length == 4;
        if (valid) {
          this.birthDatestatus = 0;
          return true;
        } else {
          this.birthDatestatus = 2;
          return false;
        }
      } else {
        this.birthDatestatus = 1;
        return false;
      }
    },
    register() {
      var birthdatestate = this.isValidDate(this.birthDate);
      this.$validator.validateAll().then((valid) => {
        if (!valid) return;
        if (!birthdatestate) return;
        var dates = this.birthDate.split("/");
        this.loading = true;
        let that = this;
        this.signUserUp({ email: that.email, password: that.password })
          .then(() => {
            let newUser = that.user();
            RegisterCustomer(newUser.id, {
              Email: that.email,
              PhoneNumber: that.phoneNumber,
              Address: that.address,
              BirthDate: new Date(
                Number(dates[2]),
                Number(dates[1]) - 1,
                Number(dates[0])
              ),
              FirstName: that.firstName,
              LastName: that.lastName,
              HQCompanyID: that.currentStoreDoc.HQCompanyID,
            })
              .then((response) => {
                var customerCode = "";
                if (response.data.Success) {
                  customerCode = response.data.Customer.CustomerMemberCode;
                }
                updateUser(newUser.id, {
                  FirstName: that.firstName,
                  LastName: that.lastName,
                  Address: that.address,
                  Mobile: that.phoneNumber,
                  BirthDate: that.birthDate,
                  DisplayName: that.firstName + " " + that.lastName,
                  FirebaseUDID: newUser.id,
                  Email: that.email,
                  CustomerMemberCode: customerCode,
                })
                  .then(() => {
                    that.loading = false;
                    if (!that.isMobile()) that.$emit("close-overlay");
                    else {
                      if (!that.storeid) that.$router.push("/");
                      else {
                        if (that.forgift && that.forgift === true)
                          that.$router.push(
                            `../../store/${that.storeid}/checkout/giftcards`
                          );
                        else
                          that.$router.push(
                            `../../store/${that.storeid}/checkout`
                          );
                      }
                    }
                  })
                  .catch(() => {
                    that.loading = false;
                    that.$emit("close-overlay");
                  });
              })
              .catch((error) => {
                that.loading = false;
                that.error = error.message;
              });
          })
          .catch((error) => {
            that.loading = false;
            that.error = error.message;
          });
      });
    },

    setAddress() {
      var that = this;
      that.address = that.$refs.gAutoComplete.$el.value;
      if (that.address) {
        this.$refs.gAutoComplete.update(that.address);
      }
    },

    async registerSoUser() {
      var birthdatestate = this.isValidDate(this.birthDate);
      this.$validator.validateAll().then((valid) => {
        if (!valid) return;
        var date = null;
        var dates = this.birthDate.split("/");
        if (birthdatestate) {
          date = new Date(
            Number(dates[2]),
            Number(dates[1]) - 1,
            Number(dates[0])
          );
        }
        var that = this;
        that.loading = true;
        CreateSoUser({
          Email: that.email,
          Mobile: that.mobile,
          Gender: that.gender ? that.gender.id: null,
          Postcode: that.postcode,
          BirthDate: date,
          FirstName: that.firstName,
          LastName: that.lastName,
          HQCompanyID: that.currentStoreDoc.HQCompanyID,
          PreferredStore: that.preferredStore ? that.preferredStore.ID : null,
        })
          .then(async (response) => {
            if (response.data.status == 200) {
              that.email = "";
              that.phoneNumber = "";
              that.address = "";
              that.birthDate = "";
              that.firstName = "";
              that.lastName = "";
              that.password = "";
              that.confirmPassword = "";
              that.$validator.reset();
              that.success = true;
              that.showSuccess("User registration was successful");
              this.$router.push({
                name: "finalizeSoRegisteration",
                params: { storeid: this.storeid, userId: response.data.QrCode, storename: this.currentStoreDoc.Name },
              });
            } else {
              that.success = false;
              that.showError(response.data.Status.Message);
            }
            that.loading = false;
          })
          .catch((error) => {
            that.success = false;
            that.showError("User registration has error");
            that.loading = false;
            that.error = error.message;
          });
      });
    },
  },
};
